var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23906 1.2523L0.518535 8.97297C0.340128 9.15137 0.242188 9.38925 0.242188 9.6484C0.242188 9.90234 0.340128 10.1404 0.518535 10.3185L8.23173 18.032C8.41028 18.2104 8.6483 18.3086 8.90224 18.3086C9.15618 18.3086 9.39433 18.2105 9.57274 18.032L10.1408 17.4639C10.3192 17.2855 10.4177 17.0473 10.4177 16.7934C10.4177 16.5395 10.3192 16.3014 10.1408 16.1229L3.66362 9.64573L10.1483 3.16136C10.3265 2.98296 10.4249 2.74494 10.4249 2.49086C10.4249 2.23692 10.3265 1.99904 10.1483 1.8205L9.57993 1.2523C9.21029 0.882805 8.6087 0.882805 8.23906 1.2523Z",
    fill: "#696F7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftGrey);
export default __webpack_public_path__ + "static/media/arrow-left-grey.b7cf46d24df3bf261d7129d7beb5b43c.svg";
export { ForwardRef as ReactComponent };